import { STMarkerStyleDmlC, STTrendlineType } from '../../Interface/chart-v3/sdk-model.interface';
import { DEFAULT_DATA_LABEL_FONT_SIZE, DEFAULT_SHAPE_PROPS } from './const';
import type { IChartMarker, ITrendline } from '../../Interface/chart-v3/sub-chart/sub-chart-properties.interface';
import type {
    BaseDataLabel,
} from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/series-v2/common/data-label';
import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { STSchemeColorVal } from '@tencent/slide-sdk-pb-model';

const DEFAULT_RUN_PROPS = {
    fontSize: 11.97,
    fontWeight: 'normal',
    fontStyle: 'normal',
    textDecoration: null,
    del: 'none',
    color: {
        colorValue: 'tx1',
        colorType: 'scheme',
        lumMod: 65000,
        lumOff: 35000,
    },
    tdColor: new TDColor({
        themeKey: STSchemeColorVal.tx1,
        lumMod: 65000,
        lumOff: 35000,
    }),
};

export default class ChartDefaultValueFactory {
    public static createDataLabels(useProps?): BaseDataLabel {
        return {
            // 带上delete 导入之后会默认把下面的false都置为true，没有delete就是显示
            showVal: true,
            showCategoryName: false,
            showSeriesName: false,
            showPercent: false,
            showLegendKey: false,
            showBubbleSize: false,
            showLeaderLines: false,
            paragraphList: this.createDefaultParagraph({ fontSize: DEFAULT_DATA_LABEL_FONT_SIZE }),
            textBodyStyle: this.createDefaultTextBody(),
            ...useProps,
        };
    }

    public static createDefaultParagraph(props?: any) {
        return [
            {
                paragraphProps: {
                    defaultRunProps: {
                        ...DEFAULT_RUN_PROPS,
                        ...props,
                    },
                },
                paragraphCharacter: {},
                textRuns: [],
                endParaRPr: {
                    lang: 'ea',
                    useEndParaStyle: true,
                },
            },
        ];
    }

    public static createDefaultRun(content: string) {
        return {
            styles: {
                ...DEFAULT_RUN_PROPS,
            },
            text: content,
            type: 'run',
        };
    }

    public static createTrendline(props?: Partial<ITrendline>): ITrendline {
        return {
            type: props?.type || STTrendlineType.linear,
            dispEq: false,
            dispRSqr: false,
            props: {
                style: {
                    ...DEFAULT_SHAPE_PROPS.style,
                    border: {
                        // @ts-ignore shapeModel里border类型与实际类型不匹配
                        linecap: 'rnd',
                        style: 'sysDot',
                        width: 3,
                        // @ts-ignore TODO 开发时移除
                        color: {
                            // @ts-ignore TODO 开发时移除
                            colorValue: props?.props?.style?.border?.color?.colorValue || 'accent1',
                            colorType: 'scheme',
                        },
                        tdColor: new TDColor({
                            // @ts-ignore TODO 开发时移除
                            themeKey: props?.props?.style?.border?.color?.colorValue || STSchemeColorVal.accent1,
                        }),
                    },
                },
            },
        };
    }

    public static createDefaultTextBody() {
        return {
            wrapperStyle: {
                alignItems: 'center',
                justifyContent: 'center',
                textDirection: 'horz',
            },
            bodyStyle: {
                width: 'fit-content',
                maxWidth: '100%',
                whiteSpace: 'pre-wrap',
            },
        };
    }

    public static createDefaultMarker(props?: Partial<IChartMarker>): IChartMarker {
        return {
            symbol: STMarkerStyleDmlC.circle,
            size: 5,
            props: {
                style: {
                    border: {
                        width: 1.5,
                        color: {
                            colorValue: props?.props?.style?.border?.color?.colorValue,
                            colorType: 'scheme',
                        },
                    },
                    fillBackground: {
                        solidFill: {
                            color: {
                                colorValue: props?.props?.style?.border?.color?.colorValue,
                                colorType: 'scheme',
                            },
                        },
                    },
                },
            },
        };
    }
}
